import BaseError from "./BaseError"
/* 
 * An error from calling fetch() that can be used with other
 * aspects of this app.
 */
export default class InvalidCoordinates extends BaseError {
  constructor({ travelerX, travelerY, mapName, computedX, computedY }) {
    super(
      `Invalid coordinates ${computedX},${computedX} in map '${mapName}' for traveler at ${travelerX},${travelerY}`,
      undefined
    )
    this.travelerX = travelerX
    this.travelerY = travelerY
    this.mapName = mapName
    this.computedX = computedX
    this.computedY = computedY
  }
}
